import React from "react";
import {
  ShieldWarning, Truck, Database, ChatCircle, GoogleLogo,
  PaintBrushBroad, Package, SignIn, ClipboardText,
} from "@phosphor-icons/react";

// Quick-filter definitions (order matters — displayed L-to-R).
export const QUICK_FILTERS = [
  { key: "fraud", label: "SPB Palsu", value: "spb.verify_failed",
    Icon: ShieldWarning,
    color: "bg-red-50 text-red-700 border-red-300",
    activeClass: "bg-red-600 text-white border-red-600" },
  { key: "verify", label: "Verifikasi", value: "spb.verify_via_qr",
    Icon: ClipboardText,
    color: "bg-green-100 text-green-800 border-green-300",
    activeClass: "bg-green-600 text-white border-green-600" },
  { key: "spb", label: "SPB", value: "prefix:spb",
    Icon: Truck,
    color: "bg-blue-100 text-blue-800 border-blue-300",
    activeClass: "bg-blue-600 text-white border-blue-600" },
  { key: "master", label: "Master Data", value: "prefix:master",
    Icon: Database,
    color: "bg-amber-100 text-amber-800 border-amber-300",
    activeClass: "bg-amber-600 text-white border-amber-600" },
  { key: "so", label: "Sales Order", value: "prefix:so",
    Icon: Package,
    color: "bg-teal-100 text-teal-800 border-teal-300",
    activeClass: "bg-teal-600 text-white border-teal-600" },
  { key: "wa", label: "WhatsApp/TG", value: "prefix:whatsapp",
    Icon: ChatCircle,
    color: "bg-green-100 text-green-700 border-green-300",
    activeClass: "bg-green-700 text-white border-green-700" },
  { key: "sheets", label: "Sheets", value: "prefix:sheets",
    Icon: GoogleLogo,
    color: "bg-emerald-100 text-emerald-800 border-emerald-300",
    activeClass: "bg-emerald-600 text-white border-emerald-600" },
  { key: "layout", label: "Layout", value: "prefix:layout",
    Icon: PaintBrushBroad,
    color: "bg-pink-100 text-pink-800 border-pink-300",
    activeClass: "bg-pink-600 text-white border-pink-600" },
  { key: "auth", label: "Login/Auth", value: "prefix:auth",
    Icon: SignIn,
    color: "bg-purple-100 text-purple-800 border-purple-300",
    activeClass: "bg-purple-600 text-white border-purple-600" },
];

/** Row of 1-click category filter chips. */
export default function AuditFilterChips({ activeAction, onSelect }) {
  return (
    <div className="mb-4 flex flex-wrap gap-2" data-testid="audit-quick-filters">
      <button
        onClick={() => onSelect("__any__")}
        className={`px-3 py-1.5 border text-xs font-bold uppercase tracking-wider ${
          activeAction === "__any__"
            ? "bg-primary text-primary-foreground border-primary"
            : "bg-card hover:bg-secondary/50"
        }`}
        data-testid="quick-filter-all"
      >
        Semua
      </button>
      {QUICK_FILTERS.map((f) => {
        const Icon = f.Icon;
        const active = activeAction === f.value;
        return (
          <button
            key={f.key}
            onClick={() => onSelect(f.value)}
            className={`px-3 py-1.5 border text-xs font-bold uppercase tracking-wider flex items-center gap-1 ${
              active ? f.activeClass : f.color + " hover:opacity-80"
            }`}
            data-testid={`quick-filter-${f.key}`}
          >
            <Icon size={12} weight="fill" /> {f.label}
          </button>
        );
      })}
    </div>
  );
}
